import { ReactNode } from 'react';

import { cn } from '@/utils/tailwind';

import { Breadcrumb } from '@/types/types';

import BreadcrumbLinks from 'components/BreadcrumbLinks/BreadcrumbLinks';
import PageTitle from 'components/PageTitle/PageTitle';

interface PageHeaderProps {
  breadcrumbs?: Breadcrumb[];
  children?: ReactNode;
  className?: string;
  dataTestId?: string;
  title?: string;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  breadcrumbs,
  className,
  dataTestId,
  children,
}) => (
  <div
    className={cn(
      'mb-6 flex w-full flex-row items-center justify-between',
      className,
    )}
    data-testid={dataTestId}
  >
    <div className="flex flex-col items-start">
      {breadcrumbs && <BreadcrumbLinks breadcrumbs={breadcrumbs} />}
      {title && <PageTitle>{title}</PageTitle>}
    </div>
    <div className="flex flex-col items-end">{children}</div>
  </div>
);

export default PageHeader;
